<template>
    <div>
        <div v-if="isInfoPage === false">
            <app-header v-if="isLoginPage"></app-header>

            <router-view v-slot="{ Component }">
                <keep-alive>
                    <component :is="Component" :key="$route.fullPath" v-if="$route.meta.keepAlive==true && isUserLogined==true" />
                </keep-alive>

                <component :is="Component" :key="$route.fullPath" v-if="$route.meta.keepAlive!=true || isUserLogined!=true" />
            </router-view>
            <div class="menu-hider"><div></div></div>
            <app-footer v-if="isLoginPage && $route.meta.editPage != true"></app-footer>
        </div>
        <div v-else>
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
    //var fcmKey = "BEKrFGrxx1HOiSdAZhDFDPFxmlAY-14_9lmyX4wh-ke6YNXbyMx-Van8uh6Nwmh8PQwkgsWg6VrIbMd3MiLM6f8";
    import AppFooter from "./views/Shared/FooterPart";
    import AppHeader from "./views/Shared/HeaderPart";
    import VueSimpleAlert from 'vue3-simple-alert';
    import { store } from './store';
    import { PushNotifications } from '@capacitor/push-notifications';
    import { func } from './main';
    import { Device } from '@capacitor/device';
    import { Geolocation } from "@capacitor/geolocation";
    import { latLng } from "leaflet";
    //import { FirebaseAnalytics } from '@awesome-cordova-plugins/firebase-analytics';


    const addListeners = async () => {
        await PushNotifications.addListener('registration', token => {
            console.info('Registration token: ', token.value);

        });

        await PushNotifications.addListener('registrationError', err => {
            console.error('Registration error: ', err.error);
        });



        await PushNotifications.addListener('pushNotificationReceived', notification => {
            console.log('Push notification received: ', notification);
            func.showSuccessMessage(notification.body);
        });





        //  await FirebaseAnalytics.logEvent('notification_open', n => {
        //   console.log('Notification opened : ' + n.notification.body);
        // });

        //  await FirebaseAnalytics.logEvent('notification_received', n => {
        //   console.log('Notification opened : ' + n.notification.body);
        // });
    }
    //import NotificationBox from './NotificationBox.vue'

    const registerNotifications = async () => {
        let permStatus = await PushNotifications.checkPermissions();

        if (permStatus.receive === 'prompt') {
            permStatus = await PushNotifications.requestPermissions();
        }

        if (permStatus.receive !== 'granted') {
            throw new Error('User denied permissions!.');
        }
        else {
            console.log("granted!");
        }

        await PushNotifications.register();
    }

    export default {
        data() {
            return {
                logDeviceInfo: null,
                lockObj: {
                    title: "ثبت موقعیت",
                    userPresenceId: 0,
                    userId: 0,
                    isAutomatic: false,
                    description: " ",
                    createDateTime: null,
                    attList: [],
                    presenceDate: null,
                    mapLocation: null,
                    countryTitle: null,
                    cityTitle: null,
                    address: null,
                    ipAddress: null,
                    deviceInfo: " ",
                    userPresenceTypeId: 0
                },
            };
        },
        computed: {
            isLoginPage() {
                return this.$route.path != "/login" && this.$route.path != "/register";
            },
            isUserLogined() {
                return this.$store.getters.IsUserAuthenticated;
            },
            isInfoPage() {
                return (
                    this.$route.path == "/install" ||
                    this.$route.name == "Expired" ||
                    this.$route.name == "ForgotPass" ||
                    this.$route.name == "ValidateEmail"
                );
            }
        },
        methods: {
            async GetDeficeInfo() {
                this.logDeviceInfo = await Device.getInfo();

                this.lockObj.deviceInfo = this.logDeviceInfo.model + " " + this.logDeviceInfo.platform + " " + this.logDeviceInfo.operatingSystem + " " + this.logDeviceInfo.osVersion + " " + this.logDeviceInfo.webViewVersion;

            },

            CheckUserLoginStatus() {
                const url = window.location.pathname.split("/");
                let page = "";
                if (url.length > 1) {
                    page = url[1];
                }
                this.$http
                    .get("Account/CheckUserStatus?page=" + page)
                    .then((data) => {
                        if (!data.data.isSuccess) {

                            this.$http
                                .get("Account/LogOutUserStatus")
                            if (data.data.errorMessage != "1") {
                                VueSimpleAlert.alert("شما از حساب کاربری خود خارج شده اید. به صفحه ورود هدایت می شوید", null, "warning", { confirmButtonText: "تایید" }).then(() => {
                                    document.location.href = "/login";
                                });
                            }

                        }
                    });
            },
            SendUserPresenceApp() {

                this.$http
                    .get("UserPresence/GetAutoUserLocationStatus")
                    .then((data) => {
                        var res = data.data;
                        if (res.isSuccess) {
                            this.$http.get("Task/GetServerDateTime")
                                .then(data => {
                                    this.lockObj.presenceDate = data.data.split("_")[0];
                                    this.lockObj.createDateTime = data.data.replace("_", " ");
                                    this.$store.dispatch("CreateUserPresenceAutomatic", this.lockObj);
                                });

                        } else {
                            this.StopAutomaticApp();
                        }
                    });

            },
            StartAutomaticApp() {
                try {

                    this.$http
                        .get("UserPresence/AutoUserLocationStart")
                        .then((data) => {
                            var res = data.data;
                            if (res.isSuccess) {
                                this.lockObj.isAutomatic = true;
                                this.getCurrentPositionApp();
                                this.interval = setInterval(() => this.getCurrentPositionApp(), 60000);
                            }
                        });

                } catch (e) {
                    console.log(e);
                }
            },
            StopAutomaticApp() {
                try {

                    this.$http
                        .get("UserPresence/AutoUserLocationStop")
                        .then((data) => {
                            var res = data.data;
                            if (res.isSuccess) {
                                this.lockObj.isAutomatic = false;
                                clearInterval(this.interval);
                            }
                        });
                } catch (e) {
                    console.log(e);
                }

            },
            GetAutoUserLocationStatusApp() {
                this.$http
                    .get("UserPresence/GetAutoUserLocationStatus")
                    .then((data) => {
                        var res = data.data;
                        if (res.isSuccess) {
                            this.lockObj.isAutomatic = false;
                            clearInterval(this.interval);
                            this.StartAutomaticApp();
                        } else {
                            this.StopAutomaticApp()
                        }
                    });
            },
            async getCurrentPositionApp() {
                try {
                    const coordinates = await Geolocation.getCurrentPosition({
                        enableHighAccuracy: true
                    });
                    console.log(coordinates.coords.latitude);
                    this.lockObj.mapLocation = coordinates.coords.latitude + "," + coordinates.coords.longitude;
                    this.mapLocationObject = latLng(coordinates.coords.latitude, coordinates.coords.longitude);
                    this.lockObj.address = await this.getAddressApp();
                    this.SendUserPresenceApp();

                }
                catch (ex) {
                    console.log(ex);
                }

            },
            async getAddressApp() {
                //this.loading = true;
                let address = "Unresolved address";
                try {
                    const { lat, lng } = this.mapLocationObject;
                    const result = await fetch(
                        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&accept-language=fa-IR`
                    );
                    if (result.status === 200) {
                        const body = await result.json();

                        address = body.display_name;
                    }
                } catch (e) {
                    console.error("Reverse Geocode Error->", e);
                }
                //this.loading = false;

                return address;
            },
            MobileAppUpdates() {

                if (!this.isFreeVersion) {
                    this.$http.get("Account/GetMobileAppUpdate?appVersionCode=" + this.appVersionCode)
                        .then(data => {
                            let lastUpdate = data.data;
                            if (lastUpdate.versionCode != undefined && lastUpdate.versionCode != null && lastUpdate.versionCode != "") {
                                if (lastUpdate.forceUpdate) {
                                    if (location.pathname != "/AppUpdate" && location.pathname != "/") {
                                        window.location = "/AppUpdate";
                                    }
                                } else {
                                    if (location.pathname === "/")
                                        VueSimpleAlert.confirm(
                                            "نسخه " + lastUpdate.versionCode + " در دسترس می باشد،آیا مایل به مشاهده و بروزرسانی هستید؟ ",
                                            null,
                                            "question",
                                            { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                                        ).then(() => {
                                            window.location = "/AppUpdate";
                                        });
                                }
                            }
                        });
                }
            },
            CheckUserStatus() {
                this.MobileAppUpdates();
                if (
                    this.$router.name != "Expired" &&
                    this.$route.meta.isOrder != true &&
                    this.isMinVersion == true &&
                    this.isLoginPage == true
                ) {
                    this.$store.dispatch("GetUserTaskStatusFromServer");
                }
            },
            loadScripts() {
                let recaptchaScript = document.createElement("script");
                recaptchaScript.setAttribute("id", "customjsScript")
                recaptchaScript.setAttribute("src", "./assets/scripts/custom.js");
                var exist = document.getElementById("customjsScript");
                if (exist) {
                    exist.remove();
                }

                document.head.appendChild(recaptchaScript);
            }
        },
        watch: {
            $route() {
                this.CheckUserStatus();
                this.CheckUserLoginStatus();
                document.getElementsByClassName("menu-hider")[0].click();
                this.loadScripts();
            },
        },
        name: "App",
        components: {
            appFooter: AppFooter,
            appHeader: AppHeader,
        },
        async mounted() {
            this.loadScripts();
            this.CheckUserStatus();
            this.CheckUserLoginStatus();
            await this.GetDeficeInfo();
            await addListeners();

            await PushNotifications.addListener('pushNotificationActionPerformed', res => {

                this.$router.push(res.notification.data["linkToOpen"].replace("/tsk", "").replace("/TSK", ""));

            });

            await registerNotifications();


            //this.$messaging.getToken({ vapidKey: fcmKey }).then((currentToken) => {
            //    if (currentToken) {
            //        console.log("regist token:" + currentToken);
            //        alert(currentToken);
            //       this.$store.dispatch("AddUserDevice", { fcmToken: currentToken });
            //   } else {
            //        console.log('No registration token available. Request permission to generate one.');
            //    }
            //}).catch((err) => {
            //    console.log('An error occurred while retrieving token. ', err);
            //})
        },
        created() {
            //this.loadScripts();
            this.GetAutoUserLocationStatusApp();
            this.$store.dispatch("GetApplicationMenuObjFromServer");
            this.$store.dispatch("GetHasCom");
            //this.$http.get("Account/UpdateBazaarRegist");
        }
    };
</script>
